// hooks/projectCode/context.js
import { createContext, useContext, useReducer } from 'react';
import { projectCodeReducer, initialState } from './reducer';

const ProjectCodeContext = createContext();

export const ProjectCodeProvider = ({ children }) => {
    const [state, dispatch] = useReducer(projectCodeReducer, initialState);

    return <ProjectCodeContext.Provider value={[state, dispatch]}>{children}</ProjectCodeContext.Provider>;
};

export const useProjectCodeContext = () => {
    const context = useContext(ProjectCodeContext);
    if (!context) {
        throw new Error('useProjectCodeContext must be used within a ProjectCodeProvider');
    }
    return context;
};
